import { UntilDestroy } from '@ngneat/until-destroy';
import { untilDestroyed } from '@ngneat/until-destroy';
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { routerTransition } from "projects/backoffice/src/app/shared/animations/router.animations";
import { OfferBundleDetailsData } from "./models/offer-bundle-details-data.model";
import { OfferBundleDetailsAdapter } from "./offer-bundle-details.data";
import { HorizontalListData } from 'common';

@UntilDestroy()
@Component({
    selector: "ifb-offer-bundle-details",
    templateUrl: "./offer-bundle-details.component.html",
    providers: [OfferBundleDetailsAdapter],
    animations: routerTransition,
    standalone: false
})
export class OfferBundleDetailsComponent implements OnInit {
  data: OfferBundleDetailsData;
  statusListData: HorizontalListData[];
  applicationListData: HorizontalListData[];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly adapter: OfferBundleDetailsAdapter
  ) { }

  ngOnInit(): void {
    this.route.data
      .pipe(untilDestroyed(this))
      .subscribe((data: OfferBundleDetailsData) => {
        this.data = data;
        this.statusListData = this.adapter.adaptStatusListWidgetData(this.data);
        this.applicationListData = this.adapter.adaptApplicationListWidgetData(this.data);
      });
  }
}
